export default __webpack_public_path__ + "static/media/roadmap_mbl.79511d54.png";